var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 10.5C7.7 9.62773 8.24414 8.88398 8.78281 8.14297V8.14297C8.925 7.94883 9.06719 7.75469 9.20391 7.55781C9.74531 6.77852 10.0625 5.83516 10.0625 4.81523C10.0625 2.15469 7.90781 0 5.25 0C2.59219 0 0.4375 2.15469 0.4375 4.8125C0.4375 5.83242 0.754687 6.77852 1.29609 7.55508C1.43281 7.75195 1.575 7.94609 1.71719 8.14023V8.14023C2.25859 8.88125 2.80273 9.62773 3.0625 10.4973H7.4375V10.5M5.25 14C6.45859 14 7.4375 13.0211 7.4375 11.8125V11.375H3.0625V11.8125C3.0625 13.0211 4.04141 14 5.25 14V14M3.0625 4.8125C3.0625 5.05312 2.86562 5.25 2.625 5.25Cnan nan 2.1875 5.05312 2.1875 4.8125C2.1875 3.11992 3.55742 1.75 5.25 1.75C5.49062 1.75 5.6875 1.94688 5.6875 2.1875Cnan nan 5.49062 2.625 5.25 2.625C4.04141 2.625 3.0625 3.60391 3.0625 4.8125V4.8125",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativesIcon);
export default __webpack_public_path__ + "static/media/initiatives-icon.5515cd1c386673dda735b5febbaf3a7b.svg";
export { ForwardRef as ReactComponent };